export enum AuthError {
  NOT_SIGNED_IN = "You are not logged in (token does not exist)",
}
